import { useState } from 'react'

export const RewardsEmbeddedTabsEnum = {
  MY_REWARDS: 'my-rewards',
  CUSTOMER_REWARDS: 'customer-rewards',
} as const

export type RewardsEmbeddedTabsType =
  (typeof RewardsEmbeddedTabsEnum)[keyof typeof RewardsEmbeddedTabsEnum]

export const useRewardsEmbeddedTabs = () => {
  const [activeTab, setActiveTab] = useState<RewardsEmbeddedTabsType>(
    RewardsEmbeddedTabsEnum.MY_REWARDS
  )

  const handleChangeTab = (tab: RewardsEmbeddedTabsType) => {
    setActiveTab(tab)
  }

  return {
    activeTab,
    handleChangeTab,
  }
}
